export const SPLIT_STRING_BY_MATCHERS_ERROR_MESSAGE =
	'[splitStringByMatchers]: Matchers not found in the input string.'
